import { Twitter, Facebook, Instagram, Mail, Phone, CompanyName } from "../../../lib/constants/globalConstant";
const data={
    Twitter: Twitter,
    Facebook: Facebook,
    Instagram: Instagram,
    Mail: Mail,
    Phone: Phone,
    CompanyName: CompanyName,
}

export default data;